////// Lib. //////
//////////////////

// ...

///// Utils. /////
//////////////////

import calc_easedAnimInterval from "../utils/calc_easedAnimInterval";

function select_randPosters(posters, index_toExclude, amt) {
  const availablePosters = posters.filter((_, index) => index !== index_toExclude);
  const selectedPosters = [];
  while (selectedPosters.length < amt && availablePosters.length > 0) {
    const randomIndex = Math.floor(Math.random() * availablePosters.length);
    selectedPosters.push(availablePosters.splice(randomIndex, 1)[0]);
  }
  return selectedPosters;
}

function hidePosterAndRemove(poster, availablePosters) {
  poster.dataset.hidden = "true";
  const index_toRemove = availablePosters.indexOf(poster);
  if (index_toRemove > -1) availablePosters.splice(index_toRemove, 1);
}

// Event hdls. ///
//////////////////

// ...

///// Assets /////
//////////////////

const msgs = {
  start: ["init. random poster cycling"],
  end: ["init. random poster cycling", "init. success"],
  no_el: ["init. random poster cycling", "no valid DOM el. provided"],
};

// Method def. ///
//////////////////

export default function init_randomPosterCycling() {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  // const el_comp = this.element;
  const { posterFrames, slotMachine } = this.ref;
  const { logs, posterUrls, autoSpin, autoSpinInterval } = this.options;
  if (logs) console.log(msgs.start[0]);

  console.log("Poster URLs:", posterUrls);
  console.log("Poster frames:", posterFrames);

  ////////// Poster cycling //////////
  ////////////////////////////////////

  // Logic for cycling through random selection of available posters

  let currentRotation = 0; // Track current rotation
  let availableUrls = [...posterUrls]; // Copy of available poster URLs
  let currentPosterUrls = []; // Currently displayed posters
  let isFirstSpin = true;
  let clickedPosterUrl = null; // Store the URL of the clicked poster

  function populateFrames(urls) {
    posterFrames.forEach((frame, index) => {
      const img = frame.querySelector("img");
      img.src = urls[index] || "";

      // Add click listener to each frame to track which poster was clicked
      frame.onclick = (e) => {
        e.stopPropagation(); // Prevent triggering slotMachine click
        clickedPosterUrl = urls[index];
        console.log("🖱️ Clicked poster:", clickedPosterUrl);
        spinCylinder();
      };
    });
    currentPosterUrls = [...urls];
  }

  function getRandomPosters(availableList, count) {
    const shuffled = [...availableList];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled.slice(0, count);
  }

  function spinCylinder() {
    const cylinder = document.querySelector(".cylinder");
    const faces = 8; // Number of faces
    const degreesPerFace = 360 / faces; // 45 degrees per face

    console.log("=== NEW SPIN ===");

    // Check if we have enough posters for the next round
    if (!isFirstSpin && availableUrls.length === 0) {
      if (autoSpin) {
        window.location.reload();
        return;
      }
      alert("No more posters available!");
      return;
    }

    let removedPoster = null;
    // Remove the clicked poster from available URLs
    if (!isFirstSpin && clickedPosterUrl) {
      const urlIndex = availableUrls.indexOf(clickedPosterUrl);
      if (urlIndex > -1) {
        removedPoster = availableUrls.splice(urlIndex, 1)[0];
        console.log("🗑️ Removed poster:", removedPoster);
      } else {
        console.log("⚠️ Clicked poster not found in available URLs:", clickedPosterUrl);
      }
      clickedPosterUrl = null; // Reset for next spin
    }

    // Check again after removal
    if (availableUrls.length === 0) {
      if (autoSpin) {
        window.location.reload();
        return;
      }
      alert("No more posters available!");
      return;
    }

    // Select 8 random posters from available URLs
    const selectedPosters = getRandomPosters(availableUrls, Math.min(8, availableUrls.length));

    // Fill remaining slots with repeated posters if needed
    while (selectedPosters.length < 8 && availableUrls.length > 0) {
      selectedPosters.push(...getRandomPosters(availableUrls, 8 - selectedPosters.length));
    }
    selectedPosters.length = 8; // Ensure exactly 8 items

    console.log("🎰 Selected posters for this spin:", selectedPosters);
    console.log("📦 Remaining available posters:", availableUrls.length, "URLs:", availableUrls);

    // Calculate current face based on current rotation
    const currentFace = Math.round((currentRotation % 360) / degreesPerFace) % faces;

    // Always add at least 5 full rotations from current position
    const minSpins = 5;
    const maxSpins = 7;
    const randomSpins = Math.floor(Math.random() * (maxSpins - minSpins + 1)) + minSpins;

    // Generate a target face that's different from the current face
    let targetFace;
    do {
      targetFace = Math.floor(Math.random() * faces);
    } while (targetFace === currentFace && !isFirstSpin);

    // Add rotations to current position
    currentRotation += randomSpins * 360 + targetFace * degreesPerFace;

    // Start the rotation immediately to avoid flicker
    cylinder.style.transform = `rotateX(${currentRotation}deg)`;

    // Wait for cylinder to spin away before changing images (prevent flicker)
    setTimeout(() => {
      populateFrames(selectedPosters);
      console.log("🔄 Images updated after spin delay");
    }, 1500); // 1.5 second delay - enough time for cylinder to spin away

    isFirstSpin = false;
  }

  // Initialize with first set of posters
  if (posterUrls && posterUrls.length > 0) {
    const initialPosters = getRandomPosters(availableUrls, Math.min(8, availableUrls.length));
    // Fill remaining slots if needed
    while (initialPosters.length < 8 && availableUrls.length > 0) {
      initialPosters.push(...getRandomPosters(availableUrls, 8 - initialPosters.length));
    }
    initialPosters.length = 8;
    populateFrames(initialPosters);
  }

  // Remove the slotMachine click listener since we're now using frame clicks
  // slotMachine.addEventListener("click", spinCylinder);

  ////////// Auto-spin mode //////////
  ////////////////////////////////////

  if (autoSpin) {
    const interval = typeof autoSpinInterval === "number" && autoSpinInterval > 0 ? autoSpinInterval : 5000;
    setInterval(() => {
      // Pick a random poster from the current display to exhaust from the pool
      if (!isFirstSpin && currentPosterUrls.length > 0) {
        clickedPosterUrl = currentPosterUrls[Math.floor(Math.random() * currentPosterUrls.length)];
      }
      spinCylinder();
    }, interval);
    if (logs) console.log(`Auto-spin enabled (every ${interval}ms)`);
  }

  ///////////// Conclude /////////////
  ////////////////////////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
